<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="活动名称" name="activity_name"></c-form-item>
					<c-form-item type="checkbox"  name="start_state" :options="activityState"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="stateName"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_product_edit" color="sys" @click="navigateTo('/reward_gift_add')">新建活动</c-button>
			</m-operate>
			
			<c-table ref="table">
        <c-table-column
            label="是否启用"
            name="state"
            width="60"
        >
          <template v-slot="{data}">
            <span v-if="data.state == 1" style="color:red">禁用</span>
            <span v-if="data.state == 2" style="color:green">启用</span>
          </template>
        </c-table-column>

				<c-table-column
					label="活动状态"
					name="start_state"
          width="80"
        >
          <template v-slot="{data}">
            <span v-if="data.state == 1">--</span>
            <span v-if="data.state == 2 && data.start_state == 0" style="color:#999">未开始</span>
            <span v-if="data.state == 2 && data.start_state == 1" style="color:dodgerblue">进行中</span>
            <span v-if="data.state == 2 && data.start_state == 2" style="color:red">已结束</span>
          </template>
				</c-table-column>

        <c-table-column
            label="活动名称"
            name="activity_name"
            width="200"
        ></c-table-column>

        <c-table-column
					label="支付订单数"
					name="order_count"
				></c-table-column>
				
				<c-table-column
					label="活动时间"
					width="300"
				>
					<template v-slot="{data}">{{data.begin_date}} 至 {{data.end_date}}</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="row">
						<c-table-button @click="navigateTo(`/reward_gift_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="row.data.state == 2 && row.data.start_state != 2" @click="changeActivityState(row,1)">禁用</c-table-button>
                        <c-table-button v-if="row.data.state == 1 && row.data.start_state != 2" @click="changeActivityState(row,2)">启用</c-table-button>
                        <c-table-button v-if="row.data.state == 1 && row.data.start_state != 2" @click="navigateTo(`/reward_gift_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button v-if="row.data.state == 1 || row.data.start_state == 2" @click="deleteActivity(row)">删除</c-table-button>
						<c-table-button v-if="row.data.start_state != 2" @click="copyActivity(row)">复制</c-table-button>
          </template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_activity_gifts',
		
		data() {
			return {
				activityState: [{
						name: '未开始',
						value: 0
					}, {
						name: '进行中',
						value: 1
					}, {
						name: '已结束',
						value: 2
					}
				],
        //是否启用1（停用）2（启用）
				stateName: [{
						name: '停用',
						value: 1
					}, {
						name: '启用',
						value: 2
					}
				]
			}
		},
		
		computed: {
			activityStateText() {
				var state = {};
				this.activityState.forEach(item => {
					state[item.value] = item.name;
				});
				
				return state;
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('rewardGiftList.update', () => {
				this.$refs.search.search();
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/activityGifts/list',
					data
				});
			},
      /**
       * 启禁用
       * @param item
       * @param state
       */
			changeActivityState(item,state) {
				this.$confirm({
					text: '确定要'+(state==2?"启用":"禁用")+'满赠活动【'+item.data.activity_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/activityGifts/updateActivityState',
							data: {
								id: item.data.id,
                state:state
							},
							loading: true,
							success: () => {
								this.$message({
									text: '禁用成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			
			deleteActivity(item) {
				this.$confirm({
					text: '确定要删除此满赠活动【'+item.data.activity_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/activityGifts/delete',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			copyActivity(item) {
				this.request({
					url: '/activityGifts/copy',
					data: {
						id: item.data.id
					},
					loading: true,
					success: () => {
						this.$message({
							text: '复制成功'
						});
						this.$refs.table.update();
					}
				});
			}
		}
	}
</script>